import React from 'react';
import { Link } from 'react-router-dom';
import clipboardIcon from '../assets/clipboard.svg';
import puzzleIcon from '../assets/puzzle.svg';
import foodIcon from '../assets/food.svg';

const Explore = () => {
    const sections = [
        {
            title: "Admission & Fee",
            description: "Learn how our admissions process works and view our fee structure.",
            icon: clipboardIcon,
            link: "/admission"
        },
        {
            title: "Curriculum",
            description: "Discover our curriculum and the comprehensive provision available for your child.",
            icon: puzzleIcon,
            link: "/curriculum"
        },
        {
            title: "Healthy Eating",
            description: "Find out how we promote healthy eating and browse our menu.",
            icon: foodIcon,
            link: "/healthy-eating"
        }
    ];

    return (
        <section className="explore-section py-5">
            <div className="container">
                <h2 className="explore-heading">Explore What We Offer</h2>
                <div className="row g-4">
                    {sections.map((section, index) => (
                        <div className="col-md-4" key={index}>
                            <Link to={section.link} className="explore-card">
                                {/* Big Background Icon */}
                                <img src={section.icon} alt="" className="explore-big-icon" />

                                {/* Hover Circles */}
                                <div className="explore-circles">
                                    <div className="explore-circle explore-circle-1"></div>
                                    <div className="explore-circle explore-circle-2"></div>
                                    <div className="explore-circle explore-circle-3"></div>
                                </div>

                                <div className="explore-icon-wrapper">
                                    <img src={section.icon} alt={section.title} className="explore-icon" />
                                </div>
                                <h3 className="explore-title">{section.title}</h3>
                                <p className="explore-description">{section.description}</p>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Explore;
